import { useClientConfig } from "@/context/clientConfig";

export function useBrandPatternURL(src?: string) {
  const {
    patterns: { host },
  } = useClientConfig();

  return src ? `${host}${src}` : null;
}
